import { loadStripe } from '@stripe/stripe-js';

let stripePromise = null;
let cardElement = null;
let elements = null;

export function getStripe(publishableKey) {
	if (!publishableKey) {
		return Promise.resolve(null);
	}
	if (!stripePromise) {
		stripePromise = loadStripe(publishableKey);
	}
	return stripePromise;
}

export async function mountCardElement(publishableKey, containerEl) {
	unmountCard();
	const stripe = await getStripe(publishableKey);
	if (!stripe || !containerEl) {
		return null;
	}
	elements = stripe.elements({
		appearance: {
			theme: 'flat',
			variables: {
				colorPrimary: '#1a1a1a',
				colorBackground: '#f5f5f5',
				colorText: '#1a1a1a',
				colorDanger: '#ef4444',
				fontFamily: '"DM Sans", sans-serif',
				borderRadius: '8px',
				spacingUnit: '4px',
			},
			rules: {
				'.Input': {
					border: '1px solid #e0e0e0',
					boxShadow: 'none',
					padding: '12px 16px',
				},
				'.Input:focus': {
					border: '1px solid #1a1a1a',
					boxShadow: '0 0 0 3px rgba(26, 26, 26, 0.08)',
				},
				'.Label': {
					fontWeight: '600',
					fontSize: '0.8rem',
					color: '#888888',
				},
			},
		},
	});
	cardElement = elements.create('card', {
		hidePostalCode: true,
	});
	cardElement.mount(containerEl);
	return { stripe, cardElement };
}

export function unmountCard() {
	if (cardElement) {
		try {
			cardElement.unmount();
		} catch (e) {
			/* ignore */
		}
		cardElement = null;
	}
	elements = null;
}

export async function confirmPayment(publishableKey, clientSecret) {
	const stripe = await getStripe(publishableKey);
	if (!stripe || !cardElement) {
		throw new Error('Payment form is not ready. Please wait a moment and try again.');
	}
	const result = await stripe.confirmCardPayment(clientSecret, {
		payment_method: { card: cardElement },
	});
	if (result.error) {
		throw new Error(result.error.message || 'Payment failed.');
	}
	return result.paymentIntent;
}
